var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmationLottie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 201,
    viewBox: "0 0 208 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.634 1.5C143.019 0.833333 143.981 0.833333 144.366 1.5L149.562 10.5C149.947 11.1667 149.466 12 148.696 12H138.304C137.534 12 137.053 11.1667 137.438 10.5L142.634 1.5Z",
    fill: "#F78670"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.134 67.501C24.5189 66.8343 25.4811 66.8343 25.866 67.501L31.0622 76.501C31.4471 77.1676 30.966 78.001 30.1962 78.001H19.8038C19.034 78.001 18.5529 77.1676 18.9378 76.501L24.134 67.501Z",
    fill: "#02475E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.134 99C173.519 98.3333 174.481 98.3333 174.866 99L180.062 108C180.447 108.667 179.966 109.5 179.196 109.5H168.804C168.034 109.5 167.553 108.667 167.938 108L173.134 99Z",
    fill: "#02475E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.134 181.502C93.5189 180.835 94.4811 180.835 94.866 181.502L101.794 193.502C102.179 194.169 101.698 195.002 100.928 195.002H87.0718C86.302 195.002 85.8209 194.169 86.2058 193.502L93.134 181.502Z",
    fill: "#02475E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 152,
    width: 8,
    height: 8,
    fill: "#F3BDA1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 15,
    width: 10,
    height: 10,
    fill: "#F78670"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 195.5,
    y: 44,
    width: 12,
    height: 12,
    fill: "#F3BDA1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 163.5,
    width: 12,
    height: 12,
    fill: "#F78670"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104 66C81.9442 66 64 83.9442 64 106C64 128.056 81.9442 146 104 146C126.056 146 144 128.056 144 106C144 83.9442 126.056 66 104 66ZM124.817 92.5942L98.9712 123.363C98.6876 123.701 98.3349 123.974 97.9367 124.163C97.5386 124.353 97.1043 124.455 96.6635 124.462H96.6115C96.1803 124.461 95.7538 124.371 95.3599 124.195C94.966 124.019 94.6134 123.763 94.325 123.442L83.2481 111.135C82.9668 110.836 82.7479 110.485 82.6044 110.1C82.4609 109.716 82.3957 109.307 82.4125 108.898C82.4293 108.488 82.5279 108.086 82.7024 107.715C82.8769 107.343 83.1238 107.011 83.4286 106.737C83.7334 106.462 84.09 106.252 84.4774 106.117C84.8648 105.983 85.2751 105.927 85.6844 105.953C86.0936 105.98 86.4934 106.087 86.8604 106.271C87.2273 106.454 87.554 106.708 87.8212 107.019L96.5308 116.696L120.106 88.6365C120.635 88.0252 121.383 87.6464 122.189 87.5822C122.994 87.518 123.793 87.7735 124.412 88.2934C125.031 88.8133 125.42 89.5559 125.496 90.3607C125.572 91.1655 125.328 91.9678 124.817 92.5942Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 104,
    y1: 66,
    x2: 116.754,
    y2: 146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78670"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationLottie);
export default __webpack_public_path__ + "static/media/confirmationLottie.f32f0e405025567e1070cb307d767823.svg";
export { ForwardRef as ReactComponent };